import img1 from "../assets/network/technology/airtel.png";
import img2 from "../assets/network/technology/Audit360.jpg";
import img3 from "../assets/network/technology/CAMS.png";
import img4 from "../assets/network/technology/gupshup.jpeg";
import img5 from "../assets/network/technology/i2k2.png";
import img6 from "../assets/network/technology/instasafe.png";
import img7 from "../assets/network/technology/leegality.png";
import img8 from "../assets/network/technology/markytics.jpeg";
import img9 from "../assets/network/technology/nelito.png";
import img11 from "../assets/network/technology/setu.jpeg";
import img12 from "../assets/network/technology/sify.png";
import img13 from "../assets/network/technology/signdesk.png";
import capital from "../assets/network/1.png";
import Insurance from "../assets/network/2.jpg";
import mfin from "../assets/network/3.png";
import saDhan from "../assets/network/4.jpg";
import upma from "../assets/network/5.png";
import crif from "../assets/network/6.png";
import equifax from "../assets/network/7.png";
import transUnion from "../assets/network/8.png";
import plc from "../assets/network/9.png";

export const pageData = {
  page: [
    {
      title: "Capital",
      sections: [
        {
          id: 1,
          heading: "Capital",
          content:
            "Kotak Mahindra Bank Limited (KMBL), one of India's leading commercial private sector banks, acquired 100% equity share capital of the company. <br/> The Company is now exclusively providing its services as the Business Correspondent partner to KMBL. The Company is facilitating the extension of microfinancing through various financial products as per the requirement of the borrower.",
          image: capital,
        },
      ],
    },
    {
      title: "Insurance",
      sections: [
        {
          id: 2,
          heading: "Kotak Life Insurance Company Limited",
          content:
            "We are dedicated to protecting the financial stability of borrowers have received financial support from Kotak Mahindra Bank Limited through BSS Sonata as a trusted business correspondent partner. Our goal is assisting in extension of comprehensive insurance solutions, through the term of their loans, offering peace of mind and financial security for clients and their spouse, in challenging times. <br/> For achieving the above objective, the company has partnered with Kotak Life Insurance Company Limited which is headquartered in Mumbai and provides wide range of insurance solutions.",
          image: Insurance,
        },
      ],
    },
    // {
    //   title: "Technology",
    //   sections: [
    //     {
    //       id: 3,
    //       heading: "Partners",
    //       images: [
    //         { image: img1 },
    //         { image: img2 },
    //         { image: img3 },
    //         { image: img4 },
    //         { image: img5 },
    //         { image: img6 },
    //         { image: img7 },
    //         { image: img8 },
    //         { image: img9 },
    //         { image: img11 },
    //         { image: img12 },
    //         { image: img13 },
    //       ],
    //     },
    //   ],
    // },
    {
      title: "Industry Association",
      sections: [
        {
          id: 4,
          heading: "MFIN",
          content:
            "MFIN is the first Self-Regulatory Organisation (SRO) in the financial services sector recognized by the RBI and regulates NBFC-MFIs to ensure responsible lending and client protection. MFIN works closely with other key stakeholders and plays an active part in the larger financial inclusions dialogue through the medium of microfinance. MFIN's vision of promoting inclusive growth drives our Advocacy efforts. We engage with diverse stakeholders. MFIN's Development Initiatives aid robust development of the sector.",
          image: mfin,
        },
        {
          id: 2,
          heading: "Sa-Dhan (Association of community finance institutions)",
          content:
            "Sa-Dhan’s mission is to build the field of community development finance in India to help its member and associate institutions to better serve low-income households, particularly women, in both rural and urban India, in their quest for establishing stable livelihoods and improving quality of life. <br/> Sa-Dhan is recognized by the RBI as Self-Regulatory Organisation (SRO) for the Microfinance Sector. Sa-Dhan is recognized as National Support Organization (NSO) by National Rural Livelihood Promotion (NRLM).",
          image: saDhan,
        },
        {
          id: 3,
          heading: "Microfinance Association of Uttar Pradesh (UPMA)",
          content:
            "The concept of Microfinance in India was introduced in the late 1980s. It has evolved by drawing upon the existing institutional architecture of social and cooperative Banking as also on newer model and approaches. <br/> The main objective of UPMA is to maintain co-ordination, among Govt; RBI and the industry players, besides working as a bridge between them. A Though there are already two such bodies working in this field at the national level. However, the concept of State association is completely different from national organizations. The care is taken that there is no conflict of interest among National level bodies and State level Associations. The object of state level Association is to function as umbrella, towards safeguarding the interest of the MFIs besides, cautioning them against any unforeseen disaster at the State level. National level organizations have policy intervention goals at National level.",
          image: upma,
        },
      ],
    },
    {
      title: "Credit Bureau",
      sections: [
        {
          id: 1,
          heading: "Partners",
          images: [
            { image: crif },
            { image: equifax },
            { image: transUnion },
            { image: plc },
          ],
        },
      ],
    },
  ],
};
